import { DefinedRange } from 'materialui-daterange-picker';

export const todayStart = new Date(new Date().setHours(0, 0, 0, 0));
export const todayEnd = new Date(new Date().setHours(23, 59, 59, 999));

export const yesterdayStart = ((date) => new Date(new Date(date.setDate(date.getDate() - 1)).setHours(0, 0, 0, 0)))(
  new Date()
);
export const yesterdayEnd = ((date) => new Date(new Date(date.setDate(date.getDate() - 1)).setHours(23, 59, 59, 999)))(
  new Date()
);

export const thisWeekFirstDayStart = ((date) =>
  new Date(new Date(date.setDate(date.getDate() - date.getDay() + 1)).setHours(0, 0, 0, 0)))(new Date());
export const thisWeekLastDayEnd = ((date) =>
  new Date(new Date(date.setDate(date.getDate() - date.getDay() + 7)).setHours(23, 59, 59, 999)))(new Date());

export const lastWeekFirstDayStart = ((date) =>
  new Date(new Date(date.setDate(date.getDate() - date.getDay() - 6)).setHours(0, 0, 0, 0)))(new Date());
export const lastWeekLastDayEnd = ((date) =>
  new Date(new Date(date.setDate(date.getDate() - date.getDay())).setHours(23, 59, 59, 999)))(new Date());

export const thisMonthFirstDayStart = ((date) =>
  new Date(new Date(date.getFullYear(), date.getMonth(), 1).setHours(0, 0, 0, 0)))(new Date());
export const thisMonthLasrDayEnd = ((date) =>
  new Date(new Date(date.getFullYear(), date.getMonth() + 1, 0).setHours(23, 59, 59, 999)))(new Date());

export const lastMonthFirstDayStart = ((date) =>
  new Date(new Date(date.getFullYear(), date.getMonth() - 1, 1).setHours(0, 0, 0, 0)))(new Date());
export const lastMonthLasrDaEnd = ((date) =>
  new Date(new Date(date.getFullYear(), date.getMonth(), 0).setHours(23, 59, 59, 999)))(new Date());

export const defaultRanges: DefinedRange[] = [
  { label: 'Today', startDate: todayStart, endDate: todayEnd },
  { label: 'Yesterday', startDate: yesterdayStart, endDate: yesterdayEnd },
  { label: 'This Week', startDate: thisWeekFirstDayStart, endDate: thisWeekLastDayEnd },
  { label: 'Last Week', startDate: lastWeekFirstDayStart, endDate: lastWeekLastDayEnd },
  { label: 'This Month', startDate: thisMonthFirstDayStart, endDate: thisMonthLasrDayEnd },
  { label: 'Last Month', startDate: lastMonthFirstDayStart, endDate: lastMonthLasrDaEnd },
];
